export default __webpack_public_path__ + "static/media/LogoLogin.3466875d.svg";